import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/right.png";
import ButtonLoader from "../../components/ButtonLoader";
import { toast, ToastContainer } from "react-toastify";
import { UpdatePassword } from "../../middleware/backend_hepler";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { token } = useParams();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const decodeJWT = (token) => {
    try {
      const payload = token.split(".")[1];
      const decodedPayload = atob(payload);
      return JSON.parse(decodedPayload);
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const newErrors = {};

    if (!password) {
      newErrors.password = "Please enter a new password";
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const decoded = decodeJWT(token);
        const adminId = decoded.userId;
        if (!adminId) {
          toast.error("Invalid or expired token.");
          return;
        }

        const payload = {
          password: password,
          confirm_password: confirmPassword,
        };

        await UpdatePassword(adminId, payload);

        toast.success("Password updated successfully!");
        navigate("/login");
      } catch (error) {
        console.error("Password reset error:", error);
        toast.error("Failed to update password. Please try again.");
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-box">
          <img src={logo} alt="Logo" className="logo" />
          <h2>Reset Password</h2>
          <p>Enter your new password below.</p>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className={`form-group ${errors.password ? "error" : ""}`}>
              <label htmlFor="password">New Password</label>
              <div
                className={`input-container ${errors.password ? "error" : ""}`}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Enter new password"
                  className="signup-field"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="toggle-password-icon"
                  onClick={togglePasswordVisibility}
                />
              </div>
              {errors.password && (
                <p className="error-message">{errors.password}</p>
              )}
            </div>
            <div
              className={`form-group ${errors.confirmPassword ? "error" : ""}`}
            >
              <label htmlFor="confirmPassword">Confirm Password</label>
              <div
                className={`input-container ${
                  errors.confirmPassword ? "error" : ""
                }`}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  className="signup-field"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="toggle-password-icon"
                  onClick={togglePasswordVisibility}
                />
              </div>
              {errors.confirmPassword && (
                <p className="error-message">{errors.confirmPassword}</p>
              )}
            </div>
            {!loading ? (
              <button type="submit">Reset Password</button>
            ) : (
              <ButtonLoader />
            )}
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ResetPassword;
